import React, { useCallback, useEffect } from 'react';
import { array, bool, func, shape } from 'prop-types';

import { groupBy } from 'lodash';

import useApi from '../../hooks/useApi';
import template from 'url-template';
import lambdaBaseApi from '../../apis/lambda';

import TagSelect from '../../components/FormFields/TagSelect';

const IssueTypesUrl = template.parse('/issuetypes');

const IssueTypesFilter = ({
    disabled,
    issueTypesFilter,
    onChangeIssueTypesFilter,
    ...props
}) => {
    const [issueTypes, getIssueTypes] = useApi(() => ({
        url: IssueTypesUrl.expand()
    }), lambdaBaseApi);

    useEffect(() => {
        getIssueTypes();

        return () => {
            issueTypes.cancel();
        };
    }, []);

    const changeHandler = (defaultValues = {}) => {
        return (event) => {
            const { value } = event.target;
            const groupedValues = groupBy(value, 'type');
            const newValues = { ...defaultValues };
            Object.entries(groupedValues).forEach(([type, value]) => {
                newValues[type] = value;
            });
            onChangeIssueTypesFilter(newValues);
        };
    };

    const revisePayload = payload => {
        if (payload && payload.length) {
            payload.forEach(issue => {
                issue.name = issue.label;

                if (issue.label === 'healthAndSafety') issue.name = 'Health and Safety';
            });
        }

        return payload;
    };

    const handleChange = useCallback(
        changeHandler({
            issueTypes: []
        })
    );

    const options = [
        {
            error:     issueTypes.error,
            isLoading: issueTypes.loading,
            items:     revisePayload(issueTypes.data),
            name:      'Issue Types',
            itemProps: {
                type: 'issueTypes'
            }
        }
    ];

    const value = [...issueTypesFilter.issueTypes];

    return (
        <TagSelect
            disabled={disabled}
            grouped
            kickerText="Add any combination of Issue Types to filter by these items."
            label="Issue Types"
            name={undefined}
            onChange={handleChange}
            options={options}
            placeholder="Add Issue Type"
            value={value}
            {...props}
        />
    );
};

IssueTypesFilter.defaultProps = {
    issueTypesFilter: {
        issueTypes: []
    },
    disabled:                 false,
    onChangeIssueTypesFilter: () => {}
};

IssueTypesFilter.propTypes = {
    issueTypesFilter: shape({
        issueTypes: array.isRequired
    }),
    disabled:                 bool,
    onChangeIssueTypesFilter: func.isRequired
};

export default IssueTypesFilter;
